var _rect, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Reddit",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#f40",
    rx: "15%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 307,
    rx: 166,
    ry: 117
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 256,
    r: 42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407,
    cy: 256,
    r: 42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 114,
    r: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 16,
    d: "m256 196 23-101 73 15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f40",
    strokeWidth: 13,
    d: "m191 359c33 25 97 26 130 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f40"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 287,
    r: 31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 287,
    r: 31
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.a106ad19c5ab251e64845c72131cc181.svg";
export { ForwardRef as ReactComponent };